/* eslint-disable @typescript-eslint/no-explicit-any */
import { Reducer } from 'redux';
import authSlice, { AUTH_KEY_IN_STORE } from './slice';
import { authSaga } from './sagas';

export class AuthModule {
	getRootKeyInStore(): string {
		return AUTH_KEY_IN_STORE;
	}

	getReducers(): Reducer {
		return authSlice.reducer;
	}

	getSagas(): () => Generator<any, void, any> {
		return authSaga;
	}
}

export const moduleInstance = new AuthModule();
